const THREE_D_SECURE_METHOD_IFRAME_ID = 'threeDSMethodIframe';

const create3DSMethodIframe = (threeDSMethodURL: string): HTMLIFrameElement => {
  const iframe = document.createElement('iframe');
  iframe.src = threeDSMethodURL;
  iframe.hidden = true;
  iframe.id = THREE_D_SECURE_METHOD_IFRAME_ID;
  iframe.name = THREE_D_SECURE_METHOD_IFRAME_ID;
  iframe.width = '0';
  iframe.height = '0';
  return iframe;
};

export const invoke3DSecureMethod = (threeDSMethodURL: string): void => {
  const iframe = create3DSMethodIframe(threeDSMethodURL);
  document.body.appendChild(iframe);
};
